import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BazisSelectComponent } from './select.component';

@Component({
    selector: 'bazis-sort',
    templateUrl: './sort.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisSortComponent extends BazisSelectComponent {
    // дефолтное значение, необходимо для списков сортировки и подобным,
    // когда что-то обязательно должно быть выбрано
    @Input() defaultValueId: string;

    @Input()
    titleMobileKey: string;

    @Input()
    titleMobileParams: string;
}
